import React from 'react';
import Avatar, { AvatarSize } from '@ingka/avatar';
import { convertBlobToImageSrc } from 'utils/blob';
import { useTranslation } from 'react-i18next';
import classes from './ProfilePicture.module.scss';

interface ProfilePictureProps {
    imageSource: string | null;
    size: AvatarSize;
}
const getImageSource = (imageSrc: string) => convertBlobToImageSrc(imageSrc, 'jpeg');

const ProfilePicture: React.FC<ProfilePictureProps> = ({ imageSource, size }) => {
    const { t } = useTranslation();

    return (
        <div className={classes[`profile-picture--${size}`]} data-testid="profile-picture">
            <Avatar
                data-testid={imageSource ? 'user-profile-picture' : 'user-no-profile-picture'}
                variant={imageSource ? 'primary' : 'secondary'}
                size={size}
                imageProps={imageSource ? { src: getImageSource(imageSource), alt: 'profilePicture', loading: 'lazy' } : undefined}
                withIcon={!imageSource}
                staticColour
                screenReaderText={t('USER_PROFILE_PICTURE')}
            />
        </div>
    );
};

export default ProfilePicture;
